/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Inc/Exc VAT toggle (#vat_toggle in the announcement bar).
 * Ported from the previous Warehouse 5.1.0 theme.js — this handler did not survive the
 * upgrade to 7.0.1 (which ships its own compiled theme.js), so it lives here in custom.js
 * to remain upgrade-safe. Stores the choice in cart.attributes.vat ('1' = exc. VAT) and
 * reloads so prices re-render via the Liquid `cart.attributes.vat` checks.
 */
document.addEventListener("DOMContentLoaded", function () {
  var vatToggle = document.getElementById("vat_toggle");
  if (vatToggle) {
    vatToggle.addEventListener("change", function () {
      var vat_value = this.checked ? "1" : "0";
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { vat: vat_value } }),
      }).then(function () {
        window.location.reload();
      });
    });
  }
});

